export enum AllowedFilterFields {
  CHANNEL = "channel",
  BRAND = "brand",
  TICKET_FIELDS = "ticket_fields",
  TOPIC = "topic",
  GRADUAL_ROLLOUT = "gradual_rollout",
  TAG = "tag",
  REGULAR_ATTACHMENT = "regular_attachment",
  INLINE_ATTACHMENT = "inline_attachment",
  EMAIL = "email",
  CUSTOM_ARR = "metadata.accountFamilyARRUSD",
  ACCOUNT_TYPE = "metadata.accountType",
  CUSTOM_ARR_GLOBAL = "metadata.accountFamilyGlobalARRUSD",
  ORIGIN = "metadata.origin",
  SHIPPING_COUNTRY = "metadata.shippingCountry",
  CUSTOM_ACCOUNT_NAME = "metadata.accountName",
}

export const ACV_METADATA_FIELDS = [
  "metadata.Account_ACV__c",
  "metadata.UGC_ACV__c",
  "metadata.Loyalty_ACV__c",
];

export type FilterPolicyRule = {
  id: string;
  field: AllowedFilterFields | string; // Allow string for dynamic metadata fields
  operator: "is" | "is_not" | "contains" | "not_contains" | "gt" | "lt";
  value: string[];
};

export type FilterPolicy = {
  id: string;
  combinator: "and" | "or";
  rules: FilterPolicyRule[];
}[];

export interface TicketEvent {
  ticketId: string;
  filterPolicy: FilterPolicy;
  shouldSkip: boolean;
}

export type TicketEventResponse = TicketEvent[];
